import React from 'react'

const posts = [
  {
    id: 1,
    category: 'CTF',
    title: "TryHackMe: What's Your Name?",
    description:
      'Walkthrough of the TryHackMe "What\'s Your Name?" challenge — covering enumeration, exploitation, and key takeaways.',
    date: 'Mar 2025',
    readTime: '6 min read',
    url: 'https://www.hqphu.com/posts/tryhackme-whats-your-name',
  },
  {
    id: 2,
    category: 'QA',
    title: "The Bugs TypeScript Won't Catch in Your Playwright Tests",
    description:
      'TypeScript gives you confidence — but not immunity. A look at the runtime bugs that slip past static typing in Playwright test suites.',
    date: 'Jan 2025',
    readTime: '7 min read',
    url: 'https://www.hqphu.com/posts/the-bugs-typescript-wont-catch-in-your-playwright-tests',
  },
  {
    id: 3,
    category: 'Career',
    title: 'Overcoming Impostor Syndrome in Cybersecurity',
    description:
      'Facing fear head-on: practical strategies for dealing with impostor syndrome as you break into and grow within the cybersecurity field.',
    date: 'Nov 2024',
    readTime: '5 min read',
    url: 'https://www.hqphu.com/posts/overcoming-impostor-syndrome-in-cybersecurity-facing-fear-head-on',
  },
  {
    id: 4,
    category: 'Cloud',
    title: 'Azure: Automate Deploying DVWA Servers Using Ansible',
    description:
      'Step-by-step guide to provisioning Damn Vulnerable Web Application servers on Microsoft Azure using Ansible for repeatable, automated deployments.',
    date: 'Sep 2024',
    readTime: '8 min read',
    url: 'https://www.hqphu.com/posts/microsoft-azure-automate-deploying-dvwa-servers-using-ansible',
  },
]

export default function Writings() {
  return (
    <div className="py-24">
      <div className="text-center mb-12">
        <p className="section-label">{"// blog"}</p>
        <h2 className="text-[1.5rem] sm:text-[1.75rem] font-bold text-title mb-2">Writing & Thinking</h2>
        <p className="text-sm text-muted">
          Thoughts on security engineering, QA automation, and building reliable systems.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {posts.map(post => (
          <a
            key={post.id}
            href={post.url}
            target="_blank"
            rel="noreferrer"
            className="card group flex flex-col gap-3 p-6 hover:shadow-md transition-shadow"
          >
            <div className="flex items-center justify-between">
              <span className="tag">{post.category}</span>
              <i className="ri-arrow-right-up-line text-subtle group-hover:text-title transition-colors"></i>
            </div>
            <h3 className="font-bold text-title text-[1rem] leading-snug">{post.title}</h3>
            <p className="text-sm text-muted leading-relaxed flex-1">{post.description}</p>
            <div className="flex items-center gap-4 mt-1">
              <span className="font-mono text-[0.72rem] text-subtle">{post.date}</span>
              <span className="flex items-center gap-1 font-mono text-[0.72rem] text-subtle">
                <i className="ri-time-line text-[0.8rem]"></i>
                {post.readTime}
              </span>
            </div>
          </a>
        ))}
      </div>

      <div className="text-center mt-10">
        <a
          href="https://hqphu.com"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border border-card-border
                     bg-card-bg text-title text-sm font-medium hover:border-accent hover:text-accent
                     transition-colors shadow-sm"
        >
          View the blogs
          <i className="ri-arrow-right-up-line text-base"></i>
        </a>
      </div>
    </div>
  )
}
